import React from "react"
import { ISchedulePatternTemplate, IScheduleTemplate } from "../../../../models"
import { IconButton } from "material-ui"
import strings from "../../../../localization/strings"
import * as scheduleHelper from "../../../../helpers/scheduleHelper"
import autobind from "class-autobind"
import { lightBlue400, grey300, grey400 } from "material-ui/styles/colors"
import Copy from "../../../../../assets/icons/copy"
import ScheduleTemplateTimeinfoDetailDayView from "./ScheduleTemplateTimeinfoDetailDayView"
import * as permissionHelper from "../../../../helpers/permissionHelper"
import AuthenticationStore from "../../../../stores/AuthenticationStore"
interface IProps {
  scheduleTemplate: IScheduleTemplate
  handleChangeSelectedDay(day: number): void
  handleDeletePatternTemplates(patternTemplates: ISchedulePatternTemplate[]): void
  handleUpdatePatternTemplateQty(newPatternTemplate: ISchedulePatternTemplate, quantity: number): void
  handleOpenCloneDialog(candidateClonePatternTemplates: ISchedulePatternTemplate[], clonedDay: number): void
  handleUpdateUniquePatternTemplate(uniquePatternTemplate: ISchedulePatternTemplate): void
}
interface IState {
  selectedDay: number
}

export default class ScheduleTemplateTimeinfoDetail7DaysView extends React.Component<IProps, IState> {
  constructor(props) {
    super(props)
    this.state = {
      selectedDay: -1,
    }
    autobind(this)
  }

  componentDidMount() {
    this.handleChangeselectedDay(0)
  }

  get7DaysBySelectedDay(selectedDay: number, dayLength: number): number[] {
    const sevenDays: number[] = []
    const startDay = Math.floor(selectedDay / 7) * 7
    let endDay = Math.floor(selectedDay / 7) * 7 + 6
    endDay = dayLength - 1 > endDay ? endDay : dayLength - 1
    for (let i = startDay; i <= endDay; i++) {
      sevenDays.push(i)
    }
    return sevenDays
  }

  handleChangeselectedDay(selectedDay: number) {
    this.setState({ selectedDay })
    this.props.handleChangeSelectedDay(selectedDay)
  }

  render() {
    const dayLength = scheduleHelper.getDayLengthFromStartAndEndTime(this.props.scheduleTemplate.StartDate, this.props.scheduleTemplate.EndDate)
    this.state.selectedDay >= dayLength && this.handleChangeselectedDay(0)
    const sevenDaysForSelectedDay = this.get7DaysBySelectedDay(this.state.selectedDay, dayLength)
    const patternTemplatesForDay = scheduleHelper.getPatternTemplatesForDay(this.props.scheduleTemplate.StartDate, this.state.selectedDay, this.props.scheduleTemplate.PatternTemplates)
    return (
      <div style={{ position: "relative" }}>
        <div style={{ position: "absolute", top: -65 }}>
          <div style={{ display: "flex" }}>
            <div style={{ marginTop: 7, width: 140, marginRight: 20 }}>
              {dayLength > 7 && [
                <i
                  key="LeftArrow"
                  className={`fa fa-arrow-circle-left ${sevenDaysForSelectedDay[0] > 0 && "TimeActionBarArrow"}`}
                  style={{ color: "#aaaaaa" }}
                  onClick={() => sevenDaysForSelectedDay[0] > 0 && this.handleChangeselectedDay(sevenDaysForSelectedDay[0] - 7)}
                />,
                <span
                  key="Day"
                  style={{ fontSize: 15, marginLeft: 5, marginRight: 5, display: "inline-block", width: 100, textAlign: "center" }}
                >
                  {sevenDaysForSelectedDay.length > 1 ?
                    `${strings.formatString(strings.Day_X, sevenDaysForSelectedDay[0] + 1)} - ${strings.formatString(strings.Day_X, sevenDaysForSelectedDay[sevenDaysForSelectedDay.length - 1] + 1)}` :
                    `${strings.formatString(strings.Day_X, sevenDaysForSelectedDay[0] + 1)}`
                  }
                </span>,
                <i
                  key="RightArrow"
                  className={`fa fa-arrow-circle-right ${sevenDaysForSelectedDay[sevenDaysForSelectedDay.length - 1] < dayLength - 1 && "TimeActionBarArrow"}`}
                  style={{ color: "#aaaaaa" }}
                  onClick={() => sevenDaysForSelectedDay[sevenDaysForSelectedDay.length - 1] < dayLength - 1 && this.handleChangeselectedDay(sevenDaysForSelectedDay[0] + 7)}
                />
              ]}
            </div>
            {dayLength > 1 &&
              <div style={{ display: "flex" }}>
                {sevenDaysForSelectedDay.map((day, index) =>
                  <div
                    data-intercom-target={`ScheduleTemplates-TimeInfoDetails-7DaysView-Select-Day${index + 1}`}
                    key={day}
                    style={{
                      backgroundColor: this.state.selectedDay === day ? lightBlue400 : grey300,
                      color: this.state.selectedDay === day && "white",
                      border: "1px solid",
                      borderColor: this.state.selectedDay === day ? lightBlue400 : grey400,
                      width: 75, height: 30, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer",
                      position: "relative"
                    }}
                    onClick={() => this.handleChangeselectedDay(day)}
                  >
                    <span>{strings.formatString(strings.Day_X, day + 1)}</span>
                    {this.state.selectedDay === day && patternTemplatesForDay.length > 0 &&
                      permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.EditAccountSchedule) &&
                      <IconButton
                        data-intercom-target={`ScheduleTemplates-TimeInfoDetails-7DaysView-Btn-OpenCloneDialogForDay${index + 1}`}
                        onClick={() => this.props.handleOpenCloneDialog(patternTemplatesForDay, this.state.selectedDay)}
                        style={{ position: "absolute", right: 10, top: 8, padding: 0, width: 10, height: 10 }}
                      >
                        <Copy width={15} height={13} color="white" />
                      </IconButton>
                    }
                  </div>
                )}
              </div>
            }
          </div>
        </div>
        <ScheduleTemplateTimeinfoDetailDayView
          patternTemplates={patternTemplatesForDay}
          handleDeletePatternTemplates={this.props.handleDeletePatternTemplates}
          handleUpdatePatternTemplateQty={this.props.handleUpdatePatternTemplateQty}
          handleUpdateUniquePatternTemplate={this.props.handleUpdateUniquePatternTemplate}
        />
      </div>
    )
  }
}